// Enums
import { EnvName } from '@enums/environment.enum';

// Packages
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  appName: 'Navigator',
  envName: EnvName.DEV,
  defaultLanguage: 'en',
  apiBaseUrl: 'https://api.navigator.dev.s-marketing.ch',
  instanceUuid: '97200bff-8412-11f1-b41a-0e6b4eaa0fa5',
  gaId: 'G-HXY2S02X37',
};
